export default __webpack_public_path__ + "static/media/Icon feather-arrow-right-circle-blue.03a22824.svg";